var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStubForAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#C8D0ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12C18.7376 12 16.4902 14.2474 16.4902 17.0098C16.4902 19.7722 18.7376 22.0195 21.5 22.0195C24.2624 22.0195 26.5098 19.7722 26.5098 17.0098C26.5098 14.2474 24.2624 12 21.5 12ZM21.5 20.9062C19.3515 20.9062 17.6035 19.1583 17.6035 17.0098C17.6035 14.8612 19.3515 13.1133 21.5 13.1133C23.6485 13.1133 25.3965 14.8612 25.3965 17.0098C25.3965 19.1583 23.6485 20.9062 21.5 20.9062Z",
    fill: "#324797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7331 25.2924C26.3616 23.8998 24.5433 23.1328 22.6133 23.1328H20.3867C18.4567 23.1328 16.6384 23.8998 15.2669 25.2924C13.902 26.6782 13.1504 28.5075 13.1504 30.4434C13.1504 30.7508 13.3996 31 13.707 31H29.293C29.6004 31 29.8496 30.7508 29.8496 30.4434C29.8496 28.5075 29.098 26.6782 27.7331 25.2924ZM14.2882 29.8867C14.567 26.7292 17.1957 24.2461 20.3867 24.2461H22.6133C25.8043 24.2461 28.433 26.7292 28.7118 29.8867H14.2882Z",
    fill: "#324797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStubForAvatar);
export default __webpack_public_path__ + "static/media/stub-for-avatar.2c40edf2627e2bc8df3dd4a7c0598f8f.svg";
export { ForwardRef as ReactComponent };